export const STORAGE_CONFERENCE_CWID = 'idt_conference_cwid'
export const STORAGE_CONFERENCE_PHOTOS = 'idt_conference_photos'
export const STORAGE_CONFERENCE_TASK_ID = 'idt_conference_task_id'
